(function (e) {
  "use strict";

  let t = null;
  const i = setInterval(() => {
    if (window.ST_GLOBALS) {
      clearInterval(i);
      l().then(() => console.info("ST Trust Badge loaded"));
    }
  });

  class n {
    constructor(t) {
      this.editor = t;
      this.badgeElement = e.createElement("div");
      this.badgeItemElement = e.createElement("div");
      this.headingBadgeElement = e.createElement("div");
      this.listImageBadgeElement = e.createElement("div");
      this.imageBadgeElement = null;
    }

    render() {
      const { id: i, badges: n, template: a, selector: l, heading: s, editor: o } = this.editor;
      this.badgeElement.setAttribute("data-id", i);
      this.badgeElement.classList.add("trustBadgeWrapper");

      let d = "shine-badge-" + i;
      this.badgeElement.classList.add(d);

      if (o.animation) this.badgeElement.classList.add(o.animation);

      this.badgeItemElement.classList.add("st-inner");

      if (s.show && s.text !== "") {
        this.headingBadgeElement.classList.add("st-trust-badge-heading");
        this.headingBadgeElement.innerText = window.ST_GLOBALS.translate(s.text);
        this.badgeItemElement.appendChild(this.headingBadgeElement);
      }

      this.listImageBadgeElement.classList.add("st-images");

      n.map((nItem) => {
        this.imageBadgeElement = e.createElement("img");
        const l = nItem.libraryURL;
        const s = l.lastIndexOf("/");
        this.imageBadgeElement.setAttribute("src", t + "/assets/" + l.substring(s + 1));
        this.imageBadgeElement.setAttribute("alt", i);
        this.imageBadgeElement.setAttribute("data-src", l);
        this.listImageBadgeElement.appendChild(this.imageBadgeElement);
      });

      this.badgeItemElement.appendChild(this.listImageBadgeElement);
      this.badgeElement.appendChild(this.badgeItemElement);

      return {
        id: i,
        el: this.badgeElement,
        headingFontFamily: s.font.value,
        headingFontWeight: s.fontWeight,
        editor: o,
        template: a,
        selector: l,
        heading: s,
        className: d,
      };
    }
  }

  const a = {};

  const l = async function () {
    if (!window.ST_PLAN || window.ST_PLAN?.name === "Free" || window.ST_PLAN?.status !== "ACTIVE") return;

    t = window.ST_GLOBALS.getBaseCDN();
    const eBadges = window.ST_TRUST_BADGES || [];
    if (eBadges.length === 0) return;

    const fonts = [];
    let styles = "";

    eBadges.map((badge) => {
      const { status: isActive = false } = badge;
      if (!isActive) return;

      const rendered = new n(badge).render();
      a[rendered.id] = rendered;

      const fontData = {
        fontFamily: rendered.headingFontFamily,
        fontWeight: rendered.headingFontWeight,
      };

      if (
        typeof fontData === "object" &&
        fontData?.fontFamily &&
        !fonts.some(
          (f) =>
            f.fontFamily === fontData.fontFamily &&
            parseInt(f.fontWeight) === parseInt(fontData.fontWeight)
        )
      ) {
        fonts.push(fontData);
      }

      let o = "";
      const d = rendered.className;
      const r = rendered.editor;
      let g = "center";

      if (r.alignment === "left") g = "start";
      else if (r.alignment === "right") g = "end";

      o = `
        .${d} .st-trust-badge-heading {
          display: block;
          text-align: ${rendered.heading.alignment};
          font-size: ${rendered.heading.size}px;
          color: ${rendered.heading.color};
          font-family: ${rendered.heading.font?.value}, sans-serif;
          font-weight: ${rendered.heading.fontWeight};
          line-height: 120%;
        }
        .${d} .st-inner .st-images {
          display: flex;
          justify-content: ${g};
          flex-wrap: wrap;
        }
        .${d} .st-inner .st-images img {
          width: ${r.size}px;
        }`;

      if (r.style !== "color") {
        o += `
          .${d} .st-inner .st-images img {
            filter: gray;
            filter: grayscale(100%);
            -webkit-filter: grayscale(100%);
          }`;
      }

      if (r.border.active) {
        o += `
          .${d} .st-inner .st-images img {
            border-radius: ${r.border.radius}px;
            border: 1px solid ${r.border.color};
          }`;
      }

      let m = r.badgeSpacing?.active ? r.badgeSpacing : { top: 5, right: 5, bottom: 5, left: 5 };
      let c = r.arroundSpacing?.active ? r.arroundSpacing : { top: 20, right: 0, bottom: 20, left: 0 };

      o += `
        .${d} .st-inner .st-images img {
          margin-top: ${m.top}px;
          margin-right: ${m.right}px;
          margin-bottom: ${m.bottom}px;
          margin-left: ${m.left}px;
          object-fit: contain;
        }
        .${d} {
          padding-top: ${c.top}px;
          padding-right: ${c.right}px;
          padding-bottom: ${c.bottom}px;
          padding-left: ${c.left}px;
        }`;

      if (r.width) {
        o += `
          .${d} {
            max-width: ${r.width}%;
          }`;
      }

      styles += o;
    });

    if (fonts.length) {
      fonts.map((font) => {
        if (!window.ST_LOADED_FONTS.includes(font.fontFamily)) {
          window.ST_GLOBALS.loadFont(font);
        }
      });
    }

    window.ST_GLOBALS.addStyle(styles);
    s();
  };

  const s = async function () {
    let tPage = window.ST_GLOBALS.pageType;
    if (tPage === "product") tPage = "product_page";

    for (const nKey in a) {
      const lBadge = a[nKey];
      const { el: sEl, selector: o, template: d, id: r } = lBadge;

      if (d === "common" && o !== "") {
        let selectors = o.element.split(",");
        const position = o?.position ? o?.position : "below";

        for (let i = 0; i < selectors.length; i++) {
          let target = e.querySelector(selectors[i]);

          if (!target) {
            let n = 0;
            while (n <= 5) {
              target = e.querySelector(selectors[i]);
              if (target) break;
              await new Promise((res) => setTimeout(res, 300));
              n++;
            }
          }

          if (target) {
            let clone = sEl.cloneNode(true);
            if (position === "above") target.parentNode.insertBefore(clone, target);
            else target.parentNode.insertBefore(clone, target.nextSibling);
          }
        }
      } else if (tPage === d) {
        let lang = e.getElementsByTagName("html")[0].getAttribute("lang");
        let selector = "";

        if (d === "product_page") selector = window.ST_GLOBALS.selectorForm;
        else if (d === "cart") selector = 'button[name="checkout"]';

        if (selector !== "") {
          let elements = e.querySelectorAll(selector);

          if (d === "cart") {
            if (!elements.length) {
              elements = e.querySelectorAll(`form[action="/cart"], form[action="/${lang}/cart"]`);
            }
            if (!elements.length) {
              elements = e.querySelectorAll(`form[action="/checkout"], form[action="/${lang}/checkout"]`);
            }
          }

          if (elements.length) {
            for (let i = 0; i < elements.length; i++) {
              if (d === "cart") elements[i].parentNode.style.flexWrap = "wrap";
              let clone = sEl.cloneNode(true);
              elements[i].parentNode.insertBefore(clone, elements[i].nextSibling);
            }
          }
        }
      } else if (d === "block") {
        const targets = e.querySelectorAll(".shine-trust-badge:not(.shine-shown)");
        for (let i = 0; i < targets.length; i++) {
          if (targets[i].getAttribute("data-id") === r) {
            let clone = sEl.cloneNode(true);
            targets[i].appendChild(clone);
            targets[i].classList.add("shine-shown");

            const preview = targets[i].querySelector(".st-editor-preview");
            if (preview) preview.style.display = "none";
          }
        }
      }
    }
  };
})(window.document);
